export default __webpack_public_path__ + "static/media/goscnew.c8051ac1.gif";